import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34b38a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"p-p-3 bg-white\" data-v-34b38a32><div class=\"p-d-flex p-jc-between\" data-v-34b38a32><div data-v-34b38a32>หมายเลขติดตามผล:</div><div class=\"p-success\" data-v-34b38a32>RET20200401</div></div><div class=\"p-d-flex p-jc-between\" data-v-34b38a32><div data-v-34b38a32>10 พ.ย. 2563 (19:23:05)</div><div class=\"p-success f-size-14\" data-v-34b38a32>รอตรวจสอบ</div></div></div>", 1)
const _hoisted_2 = { class: "p-mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "p-p-3 bg-white f-size-14"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, "หมายเลขคำสั่งซื้อ: FAQ985432"),
  /*#__PURE__*/_createElementVNode("div", { class: "p-success" }, "10 พ.ย. 2563 (19:23:05)")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, "ชื่อ-นามสกุล: อารยา ชูทอง"),
  /*#__PURE__*/_createElementVNode("div", { class: "p-success f-size-14" }, "Line")
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "border-top border-bottom f-size-14"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex bg-color-secondary p-py-2 p-px-3 product-panel" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-my-auto" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "https://cmg-chatshop-api.dosetech.co/productImage/211101121152889.jpg",
        class: "product-image"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "p-ml-2 p-d-flex p-flex-column" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-text-bold p-jc-between" }, [
        /*#__PURE__*/_createElementVNode("div", null, "Chanel Rouge Allure Velvet Matte Lip Color #71"),
        /*#__PURE__*/_createElementVNode("div", { class: "p-ml-2" }, "x1")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex f-size-14 p-mt-auto p-jc-between" }, [
        /*#__PURE__*/_createElementVNode("div", null, "฿2590"),
        /*#__PURE__*/_createElementVNode("div", { class: "p-ml-2" }, "฿2590")
      ])
    ])
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "p-p-3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex f-size-14 p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, "1 รายการ"),
  /*#__PURE__*/_createElementVNode("div", null, "฿1259.00")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ"),
  /*#__PURE__*/_createElementVNode("div", null, "฿1259.00")
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnSendProductForm = _resolveComponent("ReturnSendProductForm")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, {
        header: "ช่องทางการชำระเงิน",
        toggleable: true,
        collapsed: _ctx.isCollapsed,
        "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCollapsed) = $event)),
        class: "return-product-panel"
      }, {
        icons: _withCtx(() => [
          (!_ctx.isCollapsed)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "pi pi-chevron-up",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
              }))
            : _createCommentVNode("", true),
          (_ctx.isCollapsed)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "pi pi-chevron-down",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.isDisplayProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.isDisplayProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.isDisplayProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.isDisplayShipProductForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_ReturnSendProductForm, { isDisableShipping: _ctx.isDisableShipping }, null, 8, ["isDisableShipping"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["collapsed"])
    ])
  ]))
}